<div [class.transparent]="loading" class="flex items-center">
  <p class="label" *ngIf="label">{{ label }}</p>
  <ng-content></ng-content>
</div>
<lib-icon
  name="button-loader"
  class="loader"
  [class.transparent]="!loading"
></lib-icon>
